import type { FaireProductEntity } from "../../entity_types/product";

export const p_en52fkxk94: FaireProductEntity = {
  token: "p_en52fkxk94",
  type: "product",
  name: "18K Gold Layered Zircon Bracelet in Titanium_CWAJE4648",
  brandToken: "b_3eopd3scey",
  brandName: "ACCITY",
  imageUrl:
    "https://cdn.faire.com/fastly/0a4743b2f40cb7abca1a31bc3d688a4308e85fbabe25be6a9c03896229e34990.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dd594f8b041f8b96c0b28060e0f9effa62b5b922a05d334219da077d4d89abc8.jpeg",
    "https://cdn.faire.com/fastly/047163697a34fcf3d45031be14f49494b48e30e8bdca2f036f12a06bcf85539e.jpeg",
    "https://cdn.faire.com/fastly/266e2c3793b3be988b3042eef4c3ae8d1b886e7689f507b651d1c9dca3490353.jpeg",
    "https://cdn.faire.com/fastly/c4beb1e601095c32e71dc3d4ac94b3bab68f546110d4b3f76fb72ee1295e0e87.jpeg",
  ],
  priceDollars: 10.39,
  description:
    "▸ Material:316L Surgical-Grade Stainless Steel (Nickel-Free & Hypoallergenic)\n▸ Weight: 1.1 oz (30g)\n\nTypes Of Products That Will Be On The Shelves During This Period:\nBeaded bracelet ,Beaded bracelets for women ,Beaded bracelet set ,Beaded bracelet bulk ,Beaded bracelets with stretchy bands ,Beaded bracelet stack ,Beaded bracelet with charm ,Beaded bracelet gold filled ,Beaded bracelets with magnetic clasps,Beaded bracelet keychain ,Woven bracelet ,Woven bracelet custom ,Woven bracelet with tassel ,Woven bracelet with matching anklet ,Woven bracelet with toggle clasp ,Woven bracelet boho ,Woven bracelets ,Woven bracelet with macrame technique ,Woven bracelet diy ,Woven bracelet kit ,Braided bracelet ,Braided bracelets Gold braided bracelet ,Red braided bracelet ,Blue braided bracelet ,Back to school braided bracelets ,Green braided bracelet ,Colorful braided bracelets ,Western braided bracelet ,Yellow braided bracelet ",
  tags: [],
  msrpDollars: 20.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:33.279Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
